<template>
    <h2 class="mt-0">Tags</h2>

    <h3>Active</h3>
    <DsTag
        text="Active"
        variant="active"
    />

    <h3>Inactive</h3>
    <DsTag
        text="Inactive"
        variant="inactive"
    />

    <h3>Success</h3>
    <DsTag
        text="Success"
        variant="success"
    />

    <h3>Warning</h3>
    <DsTag
        text="Warning"
        variant="warning"
    />

    <h3>Error</h3>
    <DsTag
        text="Error"
        variant="error"
    />

    <h3>In context</h3>
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Status</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Muhammad Ali</td>
                <td>One Two Punch, Louisville, KY 40018</td>
                <td>
                    <DsTag
                        text="Final Count"
                        variant="inactive"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Craig Biggio</td>
                <td>6418 Brompton St, Houston, TX 77005</td>
                <td>
                    <DsTag
                        text="Astros"
                        variant="active"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Alex Morgan</td>
                <td>2024 Gooooooooooal Rd, San Diego, CA 91911</td>
                <td>
                    <DsTag
                        text="Gold Medalist"
                        variant="warning"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Barry Allen</td>
                <td>West House, Earth-1</td>
                <td>
                    <DsTag
                        text="Very fast"
                        variant="success"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
            <tr>
                <td>Kennedy Space Center</td>
                <td>T - 5</td>
                <td>
                    <DsTag
                        text="Launch imminent"
                        variant="error"
                    />
                </td>
                <td class="text-center">
                    <FontAwesomeIcon
                        class="cursor-pointer text-ds-primary-900"
                        icon="ellipsis"
                    />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import DsTag from '@/components/design-system/tag/DsTag.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>

<style lang="scss" scoped>
h3,
table {
    margin-top: 1em;
}

table {
    tr:nth-child(even) {
        @apply bg-ds-primary-50;
    }

    th,
    td {
        padding: 0.25em 0.75em;
    }
}
</style>
